import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'

export const createUnitSchedule = async (model: IUnitScheduledModel): Promise<IUnitScheduledModel> =>
  axios.post(`/my-monitoring/sites/AddSchedule`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitScheduledModel
}

export const useMyMonitoringCreateUnitSchedule = (
  notify?: boolean,
  onSuccess?: (data: IUnitScheduledModel) => void,
  onError?: () => void
) =>
  useMutation({
    mutationKey: ['createMyMonitoringUnitSchedule'],
    mutationFn: ({ model }: Props) => createUnitSchedule(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created schedule.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to create schedule.')
      }
      if (onError) {
        onError()
      }
    },
    throwOnError: false
  })
